export enum FitzpatrickScale {
  TYPE_I = 'TYPE_I',
  TYPE_II = 'TYPE_II',
  TYPE_III = 'TYPE_III',
  TYPE_IV = 'TYPE_IV',
  TYPE_V = 'TYPE_V',
  TYPE_VI = 'TYPE_VI',
}
